import React, { FC, ReactNode } from "react";
import { Flex } from "@evergis/ui";
import { GeometryType } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { useCalculatedAttributesVertex } from "../../../../hooks/useDialogs";
import { AttributeLabel, GeometryAttributeValue } from "../../styled";

import { FeaturedDcExtendedGeometry } from "../../../../ducks/selectFeatures/types";

type CalculatedGeometryAttributeProps = {
  value: FeaturedDcExtendedGeometry;
  label: ReactNode;
  name: string;
  isEdit?: boolean;
  formattedValue?: string;
};

export const CalculatedGeometryAttribute: FC<CalculatedGeometryAttributeProps> = ({
  value,
  name,
  label,
  isEdit,
  formattedValue,
}) => {
  const openDialog = useCalculatedAttributesVertex();
  const { t } = useTranslation("featureCard");

  if (!value) return null;

  const { coordinates, type } = value;
  const vertexCount = coordinates.length;

  return (
    <>
      <AttributeLabel isEdit={isEdit}>{label}</AttributeLabel>
      {type === GeometryType.Point ? (
        <Flex>{formattedValue || coordinates.toString()}</Flex>
      ) : (
        <GeometryAttributeValue onClick={() => openDialog(null, { value, vertexCount, label: name })}>
          {`${t("vertices")}: ${vertexCount}. ${t("showList")}`}
        </GeometryAttributeValue>
      )}
    </>
  );
};
